import { TRACK_CLICK_APP_DOWNLOAD, TRACK_APP_BANNER_CLOSE, TRACK_APP_BANNER_VISIT } from './types';

export function trackClickAppDownload(page) {
  return {
    type: TRACK_CLICK_APP_DOWNLOAD,
    payload: {
      name: 'Clicked Direct Download App Link',
      properties: {
        page,
      },
    },
  };
}

export function trackCloseAppBanner(page) {
  return {
    type: TRACK_APP_BANNER_CLOSE,
    payload: {
      name: 'App Banner Dismissed',
      properties: {
        page,
      },
    },
  };
}

export function trackVisitAppBanner(page) {
  return {
    type: TRACK_APP_BANNER_VISIT,
    payload: {
      name: 'App Banner Link Followed',
      properties: {
        page,
      },
    },
  };
}
